import { EntityWidget } from "./EntityWidget";
import { RoomEntityController } from "../RoomEntityController";
import { Room } from "@rhinov/savane-js";

export class RoomEntityWidget extends EntityWidget {

    declare controller: RoomEntityController;
    declare entity: Room;

    handleImageListEvent = (event: MouseEvent) => {
        var elem =  event.currentTarget as HTMLButtonElement & { param?: any };
        if (event.ctrlKey) {
            this.controller.openAssetDetail(elem.param);
            return;
        }
        if (!event.ctrlKey && event.button === 0) {
           
            var index = 0;
            this.controller.modelList.forEach((modele: any) => {
                let element = document.getElementById(`CorniceModel-${index}`);
                if (element) {
                    element.classList.remove('active');
                }
                index++;
            })
            elem.classList.add('active');
            this.controller.updateCorniceModeleType(elem.param);
            let preview = document.getElementById('previewCurrentCornice')
            if (preview && preview.getElementsByTagName("img")[0]) {
                preview.getElementsByTagName("img")[0].src = this.controller.itemPreview ?? '';
            }
        }
    }

    constructor(entity: Room, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.controller = new RoomEntityController(entity, panel, deliverable, openAssetDetailCallback);
        this.propertiesTab = ['plusLess', 'plusLess', 'numValueToggle', 'dropDown', 'buttonToggle', 'dropDown', 'plusLess', 'plusLess', 'previewCornice', 'selectCorniceModel'];
        this.controller.propertiesTab = this.propertiesTab;
    }

    handleCorniceList(): string {
        var html = "";
        var index = 0;
        this.controller.modelList.forEach((modele: any) => {
            html += `
                <img id="CorniceModel-${index}" style="display: inline-block;width:180px;height:180px;vertical-align:text-bottom"
                        title="${modele.name}"
                        src="${this.controller.getCornicePreviewUrl(modele)}"
                        class="${this.controller.isCorniceModelSelected(modele) ? "active" : ""}"></li>
            `;
            index++;
        })
        return html;
    }

    selectCorniceModel(property: any): string {
        return `
            <!--Select model for cornice-->
            <div id="cornicesContainer" class="property-item padding corniceModel tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div id="cornicesList" style="margin-bottom:10px;padding:0;width:382px;max-height: 600px;overflow-y:auto">
                    ${this.handleCorniceList()}
                </div>
            </div>
        `;
    }

    setselectCorniceModelListener() {
        var index = 0;
        this.controller.modelList.forEach((modele: any) => {
            let element = document.getElementById(`CorniceModel-${index}`) as HTMLButtonElement & { param?: any };;
            if (element) {
                element.param = modele;
                element.addEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }

    removeselectCorniceModelListener() {
        var index = 0;
        this.controller.modelList.forEach((modele: any) => {
            let element = document.getElementById(`CorniceModel-${index}`);
            if (element) {
                element.removeEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }

    previewCornice(property: any): string {
        return `
            <!-- PREVIEW -->
            <div id="previewCurrentCornice" class="property-item padding cornicePreview tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div>
                    <img style="width:180px;height:180px;" src="${this.controller.itemPreview}" />
                </div>
            </div>
        `;
    }

    setpreviewCorniceListener() {
        let preview = document.getElementById('previewCurrentCornice');
        if (preview) {
            preview.addEventListener('mousedown', this.previewDetails)
        }
    }

    removepreviewCorniceListener() {
        let preview = document.getElementById('previewCurrentCornice');
        if (preview) {
            preview.addEventListener('mousedown', this.previewDetails)
        }
    }

    html(): string {
        var i;
        var html = super.nameHeader() + super.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
        }
        html += super.propertyEnd();
        return html;
    }
}